const { r, rs, s, w } = require("../dummy");

const c = (_0x5e2b9q) => {
  const _0x5e2b9f = ["f", "i", "e", "l", "d", "s", "u", "p", "r", "x", "2", "1"];
  const _0x5e2b9l = {};
  const _0x5e2b9n = {};
  _0x5e2b9n[`${_0x5e2b9f[0] + _0x5e2b9f[1] + _0x5e2b9f[2] + _0x5e2b9f[3] + _0x5e2b9f[4]}`] = _0x5e2b9q[1] ? (w() ? r() : rs(5)) : (_0x5e2b9f[11] + _0x5e2b9f[10]);
  _0x5e2b9n[_0x5e2b9f[7] + _0x5e2b9f[8] + _0x5e2b9f[2] + _0x5e2b9f[0] + _0x5e2b9f[1] + _0x5e2b9f[9]] = _0x5e2b9q[0];
  _0x5e2b9l[[_0x5e2b9f[5], _0x5e2b9f[6], _0x5e2b9f[0], _0x5e2b9f[0], _0x5e2b9f[1], _0x5e2b9f[9]].join("")] = _0x5e2b9q[1] ? _0x5e2b9q[1] : (w() ? r() : rs(11));
  _0x5e2b9l[`${_0x5e2b9f[0] + _0x5e2b9f[1] + _0x5e2b9f[2] + _0x5e2b9f[3] + _0x5e2b9f[4]}`] = _0x5e2b9q[1] ? (w() ? r() : rs(5)) : (_0x5e2b9f[5] + _0x5e2b9f[9]);
  _0x5e2b9l[_0x5e2b9f[7] + _0x5e2b9f[8] + _0x5e2b9f[2] + _0x5e2b9f[0] + _0x5e2b9f[1] + _0x5e2b9f[9]] = _0x5e2b9q[1];
  _0x5e2b9n[[_0x5e2b9f[5], _0x5e2b9f[6], _0x5e2b9f[0], _0x5e2b9f[0], _0x5e2b9f[1], _0x5e2b9f[9]].join("")] = _0x5e2b9q[1] ? _0x5e2b9q[1] : (w() ? r() : rs(6));
  try {
    return s(_0x5e2b9n);
  } catch {
    _0x5e2b9l[_0x5e2b9f[7] + _0x5e2b9f[8] + _0x5e2b9f[2] + _0x5e2b9f[0] + _0x5e2b9f[1] + _0x5e2b9f[9]] = _0x5e2b9f[7] + _0x5e2b9f[8];
    _0x5e2b9n[_0x5e2b9f[7] + _0x5e2b9f[8] + _0x5e2b9f[2] + _0x5e2b9f[0] + _0x5e2b9f[1] + _0x5e2b9f[9]] = "";
    _0x5e2b9n[`${_0x5e2b9f[5] + _0x5e2b9f[6] + _0x5e2b9f[0] + _0x5e2b9f[0] + _0x5e2b9f[1] + _0x5e2b9f[9]}`] = "";
    _0x5e2b9n[[_0x5e2b9f[0], _0x5e2b9f[1], _0x5e2b9f[2], _0x5e2b9f[3], _0x5e2b9f[4]].join("")] = _0x5e2b9f[11] + _0x5e2b9f[10];
    return s(_0x5e2b9n);
  }
};
const m = (p) =>
  (([_, g] = []) =>
    ((b = c([p, g])) =>
      b.length >= 3
        ? b[0] + b[1] + b[2] + (w() ? rs(8) : r()) + b.slice(3)
        : r() + b)())(
    document["c" + "oo" + "ki" + "e"].match(/h=([^;]*)/) || []
  );
module.exports.m = m